<template>
    <div class="navigation">
        <!-- Navigation -->
        <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="secNav">
            <div class="container">
                <a class="navbar-brand js-scroll-trigger" href="/"><img :src="logo" alt="" /></a>
                
                <button v-if="brand != 'liteon'" class="navbar-toggler navbar-toggler-right" v-on:click="toggleMask()" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                Menu
                <i class="fas fa-bars"></i>
                </button>
                
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav text-uppercase ml-auto" v-if="brand != 'liteon'">
                        <li class="nav-item">
                        <router-link class="nav-link js-scroll-trigger" to="/parkinglot_lists">找停車場</router-link>
                        </li>
                        <li class="nav-item">
                        <router-link class="nav-link js-scroll-trigger" to="/news_lists">最新消息</router-link>
                        </li>
                        <li class="nav-item">
                        <router-link class="nav-link js-scroll-trigger" to="/contact">聯絡我們</router-link>
                        </li>
                        <li class="nav-item" v-if="!$cookie.get('access_token')">
                            <router-link class="nav-link js-scroll-trigger" to="/member_center" v-if="!$cookie.get('access_token')">會員中心</router-link>
                        </li>
                        <li class="nav-item" v-if="$cookie.get('access_token')">
                            <router-link class="nav-link js-scroll-trigger" to="/billing_lists" v-if="$cookie.get('access_token')">會員中心</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div id="mask" v-on:click="toggleMask()" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation"></div>
    </div>
</template>


<script>
export default {
  name: 'LogoNav',
  components: {
  },
  props: {
  },
  data() {
    return {
      logo: "img/" + process.env.VUE_APP_BRAND + "/nav_logo.png",
      brand: process.env.VUE_APP_BRAND
    }
  },
  mounted() {
    var navMain = $(".navbar-collapse");
    navMain.on("click", "a:not([data-toggle])", null, function () {
        navMain.collapse('hide');
        $("#mask").toggle();
    });
  },
  methods: {
      toggleMask:function() {
            $("#mask").toggle();
      }
  },
  destroyed() {
   
  }
}
</script>
